import { Mail } from "lucide-react";
import { site } from "@/config/site";
import { useScroll } from "@/lib/scroll";
import { LEGAL_DOCS, useLegal } from "@/components/Legal";
import VendraMark from "@/components/VendraMark";

// Legal links shown in the footer. The rest of the twelve policies are
// linked from inside Terms and Contact & Grievance.
const FOOTER_LEGAL = LEGAL_DOCS.filter((d) => d.foot);

export default function Footer() {
  const { scrollTo } = useScroll();
  const { open } = useLegal();
  return (
    <footer className="border-t border-hairline px-6 py-14 sm:px-10" data-testid="footer">
      <div className="mx-auto max-w-[1280px]">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <button
              onClick={() => scrollTo("#top")}
              className="block text-primaryText transition-opacity duration-300 hover:opacity-80"
              aria-label={`${site.studioName}, back to top`}
            >
              <VendraMark className="h-9 w-auto text-current" color="currentColor" />
            </button>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-mutedText">
              We turn the photography you already own into films. No crew, no
              shoot days, no disruption. A small number of properties at a time.
            </p>
          </div>

          <div>
            <span className="eyebrow">Contact</span>
            <ul className="mt-6 space-y-3 text-sm text-mutedText">
              <li>
                <a
                  href={`mailto:${site.email}`}
                  className="inline-flex items-center gap-3 transition-colors hover:text-primaryText"
                  data-testid="footer-email"
                >
                  <Mail size={14} strokeWidth={1.4} className="text-gold/80" />
                  {site.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <span className="eyebrow">Payment</span>
            <p className="mt-6 text-sm leading-relaxed text-mutedText">{site.paymentLine}</p>
          </div>
        </div>

        <div className="mt-14 border-t border-hairline pt-8">
          <ul className="flex flex-wrap gap-x-5 gap-y-2" data-testid="footer-legal">
            {FOOTER_LEGAL.map((d) => (
              <li key={d.key}>
                <button
                  onClick={() => open(d.key)}
                  className="text-xs text-mutedText/80 transition-colors duration-300 hover:text-primaryText"
                  data-testid={`footer-legal-${d.key}`}
                >
                  {d.title}
                </button>
              </li>
            ))}
            <li>
              <button
                onClick={() => open("grievance")}
                className="text-xs text-mutedText/80 transition-colors duration-300 hover:text-primaryText"
                data-testid="footer-legal-grievance"
              >
                Contact &amp; Grievance
              </button>
            </li>
          </ul>

          <p className="mt-8 text-xs text-mutedText/60">
            © {new Date().getFullYear()} {site.studioName}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
